import { Injectable } from '@angular/core';

@Injectable()
export class ValidarCorreoService {

  constructor() { }
  isEmailValido(email: string): boolean {
    let mailValido = false;

    //var EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&’+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)$/;
    var EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (email.match(EMAIL_REGEX)) {
      mailValido = true;
    }
    return mailValido;
  }
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/services/validar-correo.service.ts